import { render, staticRenderFns } from "./BranchCard.vue?vue&type=template&id=eaf98210&scoped=true"
import script from "./BranchCard.vue?vue&type=script&lang=js"
export * from "./BranchCard.vue?vue&type=script&lang=js"
import style0 from "./BranchCard.vue?vue&type=style&index=0&id=eaf98210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf98210",
  null
  
)

export default component.exports